import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDialog } from '@hooks/useDialog'
import Markdown from 'markdown-to-jsx'
import { prestashopUserGuideContent } from './prestashopUserGuide'
import { gaUserGuideContent } from './gaUserGuide'
import Tabs from '@components/Tabs/Tabs'

import './TutorialConnectorDialog.css'

interface TutorialConnectorDialogProps {
  isOpen: boolean
  onClose: () => void
}

export default function TutorialConnectorDialog({
  isOpen,
  onClose
}: TutorialConnectorDialogProps) {
  const { dialogRef, handleBackdropClick } = useDialog(isOpen, onClose)
  const { locale } = useIntl()
  const baseLang = locale.split('-')[0]

  const guideContent =
    baseLang === 'en'
      ? prestashopUserGuideContent.en
      : prestashopUserGuideContent.es

  const [activeTab, setActiveTab] = useState<string>('prestashop')

  const TABS = [
    {
      id: 'prestashop',
      label: (
        <FormattedMessage id="tutorial-connector-dialog.prestashop.title" />
      )
    },
    {
      id: 'ga',
      label: <FormattedMessage id="tutorial-connector-dialog.ga.title" />
    }
  ]

  return (
    <dialog
      id="tutorial-connector-dialog"
      className="app-dialog"
      ref={dialogRef}
      onClick={handleBackdropClick}
      onCancel={onClose}
    >
      <div className="dialog-inner">
        <h1>
          <span className="icon icon-link" />
          <FormattedMessage id="tutorial-connector-dialog.title" />
        </h1>

        <Tabs tabs={TABS} activeTab={activeTab} onChange={setActiveTab}>
          {activeTab === 'prestashop' && (
            <section id="prestashop">
              <Markdown className="guide-content">{guideContent}</Markdown>
            </section>
          )}

          {activeTab === 'ga' && (
            <section id="ga">
              <Markdown className="guide-content">
                {baseLang === 'en'
                  ? gaUserGuideContent.en
                  : gaUserGuideContent.es}
              </Markdown>
              <a
                href="/pdf/users_guide.pdf"
                download="users_guide.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="download-link"
              >
                <FormattedMessage id="profile.analytics-dialog.error-link" />
              </a>
            </section>
          )}
        </Tabs>
      </div>
    </dialog>
  )
}
